import Backbone from 'backbone'
import Parse from 'parse'

'use strict'

// Cache configuration
const CACHE_KEY_STORY_PREFIX = 'featuredStoryHTML_';
const CACHE_EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours

function getCached(key) {
  try {
    const cached = localStorage.getItem(key);
    if (!cached) return null;

    const { data, timestamp } = JSON.parse(cached);
    if (Date.now() - timestamp > CACHE_EXPIRY_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

function setCache(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch {
    // localStorage full or unavailable - ignore
  }
}

export const FeaturedStory = Backbone.Model.extend({

    defaults: {
      id: '',
      link: '',
      date: '',
      title: '',
      excerpt: '',
      storyHTML: '',
      urlSlug: '',
      loading: true,
    },

    setHTML: async function () {
      this.set('loading', true)
      const storyHTML = await this.fetchStory(this.get('link'))

      this.set({
        storyHTML: storyHTML.trim(),
        loading: false
      })
    },

    fetchStory: async (link) => {
      const cacheKey = CACHE_KEY_STORY_PREFIX + encodeURIComponent(link);
      const cached = getCached(cacheKey);
      if (cached) return cached;

      const featuredStory = await Parse.Cloud.run('getStory', { url: link });
      setCache(cacheKey, featuredStory);
      return featuredStory;
    }

})

export default FeaturedStory
